"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getReviewStatsRequestState = exports.getReviewsFetchRequestState = exports.getReviewWriteRequestState = exports.getPortalScopeRequestState = exports.getAdminRequestState = exports.getAppIntegrationsRequestState = void 0;

var _reselect = require("reselect");

var RequestKey = _interopRequireWildcard(require("../constants/RequestKey"));

var getRequestStates = function getRequestStates(state) {
  return state.requestStates;
};

var getAppIntegrationsRequestState = (0, _reselect.createSelector)([getRequestStates], function (requestStates) {
  return requestStates[RequestKey.APP_INTEGRATIONS];
});
exports.getAppIntegrationsRequestState = getAppIntegrationsRequestState;
var getAdminRequestState = (0, _reselect.createSelector)([getRequestStates], function (requestStates) {
  return requestStates[RequestKey.ADMINS];
});
exports.getAdminRequestState = getAdminRequestState;
var getPortalScopeRequestState = (0, _reselect.createSelector)([getRequestStates], function (requestStates) {
  return requestStates[RequestKey.HUBS];
});
exports.getPortalScopeRequestState = getPortalScopeRequestState;
var getReviewWriteRequestState = (0, _reselect.createSelector)([getRequestStates], function (requestStates) {
  return requestStates[RequestKey.REVIEW_WRITE];
});
exports.getReviewWriteRequestState = getReviewWriteRequestState;
var getReviewsFetchRequestState = (0, _reselect.createSelector)([getRequestStates], function (requestStates) {
  return requestStates[RequestKey.REVIEWS_FETCH];
});
exports.getReviewsFetchRequestState = getReviewsFetchRequestState;
var getReviewStatsRequestState = (0, _reselect.createSelector)([getRequestStates], function (requestStates) {
  return requestStates[RequestKey.REVIEWS_STATS];
});
exports.getReviewStatsRequestState = getReviewStatsRequestState;


//////////////////
// WEBPACK FOOTER
// ./js/selectors/requestStates.js
// module id = 158
// module chunks = 209 210 211 212